import SketchOrderTierClient from "../lib/apiClients/roofSnapApiClient/sketchOrderTierClient";
import { CALL_API } from "../middleware/api";
import {
    GET_SKETCH_ORDER_TIERS_FAILURE,
    GET_SKETCH_ORDER_TIERS_REQUEST,
    GET_SKETCH_ORDER_TIERS_SUCCESS
} from "./actionTypes";

export const getSketchOrderTiers = () => {
    const sketchOrderTierClient = new SketchOrderTierClient('v1');
    const request = sketchOrderTierClient.getSketchOrderTier;

    return {
        [CALL_API]: {
            types: [
                GET_SKETCH_ORDER_TIERS_REQUEST,
                GET_SKETCH_ORDER_TIERS_SUCCESS,
                GET_SKETCH_ORDER_TIERS_FAILURE
            ],
            request
        }
    }
};
